import fs from "fs";
import template from "bundle-text:./index.html";
import { skills as skillList } from "./skills";
import { templateLoopParser } from "../parser";

const skillListTemplate = fs.readFileSync(__dirname + "/template.html", "utf8");

let skillsInitialized = false;

const initSkills = () => {
  if (skillsInitialized) return;
  skillsInitialized = true;

  const skillContainer = document.querySelector(".skill-container");
  if (skillContainer) {
    const skillContent = `<div class="skill-list">${templateLoopParser(skillList, skillListTemplate)}</div>`;
    var skills = new DOMParser().parseFromString(skillContent, "text/html");
    skills.querySelector(".skill-list").childNodes.forEach((child) => {
      skillContainer.appendChild(child);
    });
  }
};

export const Skills = () => {
  // Use requestIdleCallback for non-critical initialization
  if ("requestIdleCallback" in window) {
    requestIdleCallback(initSkills);
  } else {
    setTimeout(initSkills, 0);
  }
  return template;
};
